import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import { LocalizedPaths, TrackedEvents, trackPageView } from "@/utils";
import "@/styles/index.scss";

Vue.config.productionTip = false;
Vue.use(LocalizedPaths);
Vue.use(TrackedEvents);

// Exactly one page_view per route (index.html uses send_page_view: false).
router.afterEach((to) => {
  trackPageView(to);
});

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
